import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import faqs from './data';
import FAQ from './FAQ';
import './faqs.css';

const FAQs = () => {
  return (
    <section className="faqs section section--muted" id="faqs">
      <div className="container">
        {/* Section Header */}
        <div className="faqs__header" data-aos="fade-up">
          <div className="faqs__badge">
            <FontAwesomeIcon icon={faQuestionCircle} />
            <span>Pertanyaan Umum</span>
          </div>
          
          <h2 className="faqs__title">
          Pertanyaan yang Sering Diajukan
          </h2>
          
          <p className="faqs__subtitle">
          Berikut beberapa pertanyaan yang paling sering ditanyakan pelanggan mengenai layanan servis di iTech Service.
          </p>
        </div>

        {/* FAQ Items */}
        <div className="faqs__container" data-aos="fade-up" data-aos-delay="200">
          {faqs.map((faq, index) => (
            <div
              key={faq.id}
              data-aos="fade-up"
              data-aos-delay={300 + (index * 100)}
            >
              <FAQ faq={faq} />
            </div>
          ))}
        </div>

{/*
<div className="faqs__help" data-aos="fade-up" data-aos-delay="600">
  <div className="faqs__help-content">
    <div className="faqs__help-icon">
      <FontAwesomeIcon icon={faHeadset} />
    </div>
    
    <div className="faqs__help-text">
      <h3 className="faqs__help-title">Masih Ada Pertanyaan?</h3>
      <p className="faqs__help-description">
        Tim dukungan kami yang ramah siap membantu. Hubungi kami untuk 
        bantuan personal dengan kebutuhan perangkat Apple Anda.
      </p>
    </div>
    
    <div className="faqs__help-actions">
      <button 
        className="btn btn-primary faqs__help-button"
        onClick={() => {
          const contactSection = document.getElementById('contact');
          if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        aria-label="Hubungi tim dukungan kami"
      >
        Hubungi Dukungan
      </button>
      
      <button 
        className="btn btn-secondary faqs__help-button"
        onClick={() => {
          window.open('https://wa.me/62895339559888', '_blank', 'noopener,noreferrer');
        }}
        aria-label="Chat dengan kami di WhatsApp"
      >
        Chat di WhatsApp
      </button>
    </div>
  </div>
</div>
*/}
      </div>
    </section>
  );
};

export default FAQs;
